// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import translate from "@insite/client-framework/Translate";
import ArrowBackward from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface BackButtonPresentationProps extends ExpandStyles<BackButtonStyles> {}

export interface BackButtonProps extends BackButtonPresentationProps {
    pageLink?: PageLinkModel;
    onClick?: () => void;
}

export interface BackButtonStyles {
    button?: ButtonPresentationProps;
}

export const backButtonStyles: BackButtonStyles = {
    button: {
        icon: {
            src: ArrowBackward,
            position: "left",
        },
        sizeVariant: "medium",
        variant: "secondary",
        mergeCss: true,
        css: css`
            margin-top: ${pxToRem(20)};
        `,
    },
};

const BackButton: FC<BackButtonProps> = ({ extendedStyles, overridedStyles, pageLink, onClick }) => {
    const styles = useExpandProps(backButtonStyles, extendedStyles, overridedStyles);

    if (!pageLink?.url && !onClick) {
        return null;
    }

    return (
        <Button {...styles.button} href={!onClick ? pageLink?.url : undefined} onClick={onClick}>
            {pageLink?.title ? translate("Back to {0}", pageLink.title) : translate("Back")}
        </Button>
    );
};

export default BackButton;
